<template>
  <div class="news-box">
    <router-link :to="'/news/'+p_id">
      <div class="image">
        <img :src="require('@/assets/news/'+imgSrc)">
      </div>
      <div class="place-time">
        {{place}}, {{time}}
      </div>
      <div class="title">
        {{title}}
      </div>
      <div class="text">
        {{text}}
      </div>
    </router-link>
  </div>
</template>

<script>
import users from '@/assets/news/news-list.json'

export default {
  name: 'newsBox',
  props: {
    p_id: String
  },
  data () {
    return {
      place: users[this.p_id]['place'],
      time: users[this.p_id]['time'],
      title: users[this.p_id]['title'],
      imgSrc: users[this.p_id]['imgSrc'],
      text: users[this.p_id]['text']
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .news-box{
    height: 100%;
    text-align: left;

    a,a:visited{
      text-decoration: none;
      color: #3B3B3B;
      transition: color .3s ease;
      -webkit-transition: color .3s ease;
      .title{
        color: #3B3B3B;
        transition: color .3s ease;
        -webkit-transition: color .3s ease;
      }
      .place-time{
        color: #3B3B3B;
        transition: color .3s ease;
        -webkit-transition: color .3s ease;
      }
      .text{
        color: #3B3B3B;
        transition: color .3s ease;
        -webkit-transition: color .3s ease;
      }
    }
    a:hover{
      text-decoration: underline;
      color: #D0AF1F;
      .title{
        color: #D0AF1F;
      }
      .place-time{
        color: #D0AF1F;
      }
      .text{
        color: #D0AF1F;
      }
    }
  }
  .image{
    height: 60%;

    img{
      width: 100%;
      height: 100%;
    }
  }
  .place-time{
    color: #737B7B;
    font-size: 1vw;
    font-weight: 100;
    font-family: "ヒラギノ角ゴ Pro W3", Hiragino Kaku Gothic Pro," メイリオ", Meiryo, Osaka," ＭＳ Ｐゴシック", MS PGothic," sans-serif";
    padding-top: 2vw;
    text-decoration: underline;

    @media (max-width: 550px) {
      font-size: 18px;
    }
  }
  .title{
    color: #54595f;
    font-size: 1.3vw;
    font-weight: bolder;
    line-height: 2;
    font-family: "ヒラギノ角ゴ Pro W3", Hiragino Kaku Gothic Pro," メイリオ", Meiryo, Osaka," ＭＳ Ｐゴシック", MS PGothic," sans-serif";

    @media (max-width: 550px) {
      font-size: 16px;
    }
  }
  .text{
    color: #777777;
    font-size: 1vw;
    line-height: 2;
    font-weight: normal;
    font-family: "ヒラギノ角ゴ Pro W3", Hiragino Kaku Gothic Pro," メイリオ", Meiryo, Osaka," ＭＳ Ｐゴシック", MS PGothic," sans-serif";
    text-align: justify;
    @media (max-width: 550px) {
      margin-top: 7px;
      font-size: 15px;
      overflow: hidden;
      height: 5em;
      line-height: 1.8em;
    }
  }

</style>
